// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as InfoCircleDefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/general/info-circle.svg?react';
import { ReactComponent as InfoCircleSolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/general/info-circle.svg?react';
import { createIcons } from '../../Icon';
export const InfoCircleIcon = /* @__PURE__ */ createIcons('InfoCircle', {
    default: InfoCircleDefault,
    solid: InfoCircleSolid
});
InfoCircleIcon.supportedTypes = [
    'default',
    'solid'
];
